import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import DruvaLogo from "./druvaTextLogo";
import "./poweredByDruva.scss";

const PoweredByDruva = props => {
  const { dataTestId, white } = props;
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(props, "oui-powered-by-druva")}
    >
      <div className="oui-powered-logo">
        <DruvaLogo white={white} />
      </div>
    </div>
  );
};

PoweredByDruva.propTypes = {
  white: PropTypes.bool,
  dataTestId: PropTypes.string
};

PoweredByDruva.defaultProps = {
  white: false,
  dataTestId: "orion-powered-by-druva"
};

PoweredByDruva.displayName = "OrionPoweredByDruva";

export default PoweredByDruva;
